import { render, staticRenderFns } from "./addPass.vue?vue&type=template&id=7bcc816f&scoped=true"
import script from "./addPass.vue?vue&type=script&lang=js"
export * from "./addPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcc816f",
  null
  
)

export default component.exports